<style scoped lang="less">
@import "../../less/colors";

.image-gallery {
    margin-bottom: 1em;
    display: flex;
    flex-wrap: wrap;

    &.animate .tile {
        -webkit-transition: all 0.25s ease-in-out;
        -moz-transition: all 0.25s ease-in-out;
        -o-transition: all 0.25s ease-in-out;
        transition: all 0.25s ease-in-out;
    }

    .tile {
        position: relative;
        border: 3px solid @white;
        padding: 0;
        margin: 0;
        height: 150px;
        float: unset;

        background-position: center center;
        background-repeat: no-repeat;
        -webkit-background-size: cover;
        -moz-background-size: cover;
        -o-background-size: cover;
        background-size: cover;

        &:hover {
            opacity: 0.3;
        }

        &.info {
            overflow: hidden;
            background: @red;
            word-break: none;
            font-size: 4em;
            line-height: 1em;
            font-weight: 300;
            letter-spacing: -2px;

            &:hover {
                opacity: 1;
                background: @darkgrey;
            }

            span {
                  margin-top: 80%;
                  display: block;
            }
            a {
                color: @white;
                display: flex;
                justify-content: center;
                align-items: flex-end;
            }
        }

        a {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
        }
    }
}
</style>

<template>
    <div v-if="files">
        <div class="image-gallery" :class="{animate: heightSet}">
            <div v-if="files" class="column s50 m33 l25 xl20 tile" v-for="(file, index) in files" :key="file.id" :style="{'background-image': 'url(\'' + file.thumbs[getImageSize(file)] + '\')', height: itemWidth + 'px'}" :alt="file.name">
                <a @click="bus.$emit('show', index)"></a>
            </div>
            <div v-if="type === 'info'" class="column s50 m33 l25 xl20 tile info" ref="info" :style="{height: itemWidth + 'px'}" >
                <a :href="url"><span>{{ text }}</span></a>
            </div>
        </div>

        <image-popup :images="files" :bus="bus"></image-popup>

    </div>
</template>

<script>
    import Collection from './collection.js';
    export default {
        extends: Collection,

        data() {
            return {
                itemWidth: 150,
                heightSet: false,
                bus: new Vue,
            };
        },

        props: {
            url: String,
            text: {
                type: String,
                default: 'Meer',
            },
            type: {
                type: String,
                default: 'default',
                validator: function (value) {
                    return ['default', 'info'].indexOf(value) !== -1
                }
            },
        },

        created() {
            window.addEventListener("resize", () => this.calcHeight());
            setTimeout(() => {
                this.calcHeight();
            });
        },

        destroyed() {
            window.removeEventListener("resize", () => this.calcHeight());
        },

        methods: {

            calcHeight() {
                if (!this.$refs['info']) {
                    return;
                }

                setTimeout(() => {
                    this.itemWidth = this.$refs['info'].clientWidth;
                    this.heightSet = true;
                }, 250);
            },

            getImageSize(file) {
                const factor = Math.max(this.itemWidth / file.metadata.width, this.itemWidth / file.metadata.height);
                const maxSize = Math.max( factor * file.metadata.width,  factor * file.metadata.height);

                if (maxSize < 150) {
                    return 'x150';
                } else if (maxSize < 400) {
                    return 'x400';
                } else if (maxSize < 800) {
                    return 'x800';
                } else {
                    return 'x1024';
                }
            },

        },
    }
</script>
